import { atom } from "recoil";
export const voPacks = atom({
  key: "voPacks", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
});
